import type { Food } from '@tiffinify/core';

/** A dish from the library a kitchen can copy into its own list. Lives in the app: only Settings needs it. */
export interface CommonDish {
  name: string;
  food: Food;
  category: string;
}

/** Common, popular dishes. Kitchens add any of them to their own list in Settings, then change them freely. */
export const COMMON_DISHES: readonly CommonDish[] = [
  // High Protein
  { name: 'Boiled Eggs (3)', food: 'egg', category: 'High Protein' },
  { name: 'Scrambled Eggs (3)', food: 'egg', category: 'High Protein' },
  { name: 'Fried Eggs (3)', food: 'egg', category: 'High Protein' },
  { name: 'Paneer (100g)', food: 'veg', category: 'High Protein' },
  { name: 'Chicken Breast (200g)', food: 'nonveg', category: 'High Protein' },
  { name: 'Chicken Salad', food: 'nonveg', category: 'High Protein' },
  { name: 'Chicken Soup', food: 'nonveg', category: 'Meals' },
  { name: 'Egg Soup', food: 'egg', category: 'Meals' },
  { name: 'Whey Protein Smoothie', food: 'veg', category: 'High Protein' },

  // Combos & Meals (11)
  { name: 'Chicken Dal Rice', food: 'nonveg', category: 'Combos' },
  { name: 'Paneer Dal Rice', food: 'veg', category: 'Combos' },
  { name: 'Tofu Dal Rice', food: 'veg', category: 'Combos' },
  { name: 'Chicken Pulav', food: 'nonveg', category: 'Combos' },
  { name: 'Paneer Pulav', food: 'veg', category: 'Combos' },
  { name: 'Chicken Biriyani', food: 'nonveg', category: 'Combos' },
  { name: 'Chicken Fried Rice', food: 'nonveg', category: 'Combos' },
  { name: 'Egg Fried Rice', food: 'egg', category: 'Combos' },
  { name: 'Paneer Fried Rice', food: 'veg', category: 'Combos' },
  { name: 'Veg Fried Rice', food: 'veg', category: 'Combos' },
  { name: 'Curd Rice', food: 'veg', category: 'Meals' },

  // Bowls & Salads (10)
  { name: 'Fruit Bowl', food: 'veg', category: 'Bowls' },
  { name: 'Fruit & Salad Bowl', food: 'veg', category: 'Bowls' },
  { name: 'Sprouts Bowl', food: 'veg', category: 'Bowls' },
  { name: 'Veggie Salad', food: 'veg', category: 'Bowls' },
  { name: 'Paneer Salad', food: 'veg', category: 'Bowls' },
  { name: 'Mushroom Salad', food: 'veg', category: 'Bowls' },
  { name: 'Egg Salad', food: 'egg', category: 'Bowls' },
  { name: 'Avocado Ice Cream', food: 'veg', category: 'Bowls' },
  { name: 'Maggie', food: 'veg', category: 'Bowls' },
  { name: 'Egg Maggie', food: 'egg', category: 'Bowls' },

  // Breakfast (9)
  { name: 'Scrambled Egg Toast', food: 'egg', category: 'Breakfast' },
  { name: 'Avocado Toast', food: 'veg', category: 'Breakfast' },
  { name: 'Avocado-Scrambled Egg Toast', food: 'egg', category: 'Breakfast' },
  { name: 'Bread Omelette', food: 'egg', category: 'Breakfast' },
  { name: 'Chicken Sandwich', food: 'nonveg', category: 'Breakfast' },
  { name: 'Egg Sandwich', food: 'egg', category: 'Breakfast' },
  { name: 'Veg Sandwich', food: 'veg', category: 'Breakfast' },
  { name: 'Overnight Oat Meal', food: 'veg', category: 'Breakfast' },
  { name: 'Bread & Peanut', food: 'veg', category: 'Breakfast' },

  // Snacks & Beverages (12)
  { name: 'Sweet Potato & Veggies', food: 'veg', category: 'Snacks' },
  { name: 'Protein Ball (3 Pc)', food: 'veg', category: 'Snacks' },
  { name: 'Fresh Juice', food: 'veg', category: 'Beverages' },
  { name: 'Banana Milkshake', food: 'veg', category: 'Beverages' },
  { name: 'Protein Smoothie', food: 'veg', category: 'Beverages' },
  { name: 'Smoothie', food: 'veg', category: 'Beverages' },
  { name: 'Lime Soda', food: 'veg', category: 'Beverages' },
  { name: 'Papaya Juice', food: 'veg', category: 'Beverages' },
  { name: 'Apple Juice', food: 'veg', category: 'Beverages' },
  { name: 'Pomegranate Juice', food: 'veg', category: 'Beverages' },
  { name: 'Watermelon Juice', food: 'veg', category: 'Beverages' },
  { name: 'Chikku Juice', food: 'veg', category: 'Beverages' },
];

